/**
 * General Utilties
 */
export default function initUtilites() {

    const init = () => {
        makeHREFClickable();
        normalizeChildrenHeight();
    }

    /**
     * Make HREF Clickable
     * Look for elements with data-href and make them clickable
     */
    const makeHREFClickable = () => {
        const clickableElements = document.querySelectorAll('[data-href]');
        clickableElements.forEach((element) => {
            element.addEventListener('click', () => {
                const childAnchor = element.querySelector('a');
                if (childAnchor && childAnchor.getAttribute('target') === '_blank') {
                    window.open(childAnchor.getAttribute('href'), '_blank');
                } else {
                    window.location.href = element.getAttribute('data-href');
				}
            });
        });
    };

    /**
     * Normalize Children Height
     * Look for elements with class normalize-children-height and make them the same
     */
    const normalizeChildrenHeight = () => {

        const parentsNoralizeChildren = document.querySelectorAll('.normalize-child-height, .normalize-children-height');
        parentsNoralizeChildren.forEach((parent) => {
            const children = [...parent.children];
            const handleResize = () => {
                let maxHeight = 0;
                children.forEach((child) => {
                    child.style.height = 'auto';
                    child.style.maxHeight = '100%';
                });

                children.forEach((child) => {
                    if (child.offsetHeight > maxHeight) {
                        maxHeight = child.offsetHeight;
                    }
                });
                children.forEach((child) => {
                    child.style.height = `${maxHeight}px`;
                });
                ///console.log('maxHeight', maxHeight);
            }

            window.addEventListener('resize', handleResize);
            setTimeout( handleResize, 200 );

            // check for visibility 
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible') {
                    setTimeout(handleResize, 200);
                }
            });

            // check for visbility within the document
            const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting)  handleResize();
                    });
                }, {
                root: null,           
                rootMargin: '0px', 
                threshold: 0.1
            });

            observer.observe(parent);
            
        });
    }
    init();

}
